import { Award, Users, Clock, CheckCircle } from 'lucide-react';
import { useSlideIn } from '../hooks/useSlideIn';

const highlights = [
  {
    icon: Award,
    title: 'Zertifiziert',
    description: 'DIN ISO 9001 & DIN 14675',
  },
  {
    icon: Users,
    title: 'Erfahren',
    description: 'Qualifiziertes Fachpersonal',
  },
  {
    icon: Clock,
    title: 'Zuverlässig',
    description: 'Termintreue garantiert',
  },
  {
    icon: CheckCircle,
    title: 'Qualität',
    description: 'Hochwertige Materialien',
  },
];

export const About = () => {
  const anim = useSlideIn();
  return (
    <section id="ueber-uns" data-testid="about-section" className="py-20 md:py-32 bg-zinc-50">
      <div ref={anim.ref} className={"max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 slide-in-right" + (anim.isVisible ? " visible" : "")}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative z-10">
              <img
                src="/images/psd161i8_WhatsApp_Image_2026-03-09_at_08.29.35__1_.jpeg"
                alt="Fesch Elektrotechnik Team vor der Rathausgalerie"
                data-testid="about-image"
                className="w-full h-[500px] object-cover"
              />
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-[#E31E24] z-0 hidden lg:block" />
            
            {/* Stats Overlay */}
            <div className="absolute -bottom-8 left-8 bg-white p-6 shadow-xl z-20 hidden md:block">
              <div className="text-4xl font-bold text-[#E31E24] mb-1">100%</div>
              <div className="text-sm font-medium text-neutral-600">Kundenzufriedenheit</div>
            </div>
          </div>

          {/* Content Side */}
          <div className="lg:pl-8">
            <span className="inline-block text-[#E31E24] font-semibold text-sm uppercase tracking-widest mb-4">
              Über uns
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-neutral-900 mb-6">
              FESCH Elektrotechnik GmbH
            </h2>
            
            <div className="space-y-4 text-neutral-600 mb-8">
              <p>
                Alles begann mit einer Vision: Elektrotechnik auf höchstem fachlichen Niveau anzubieten und dabei 
                stets die individuellen Anforderungen unserer Kunden in den Mittelpunkt zu stellen.
              </p>
              <p>
                Heute sind wir ein wachsendes Unternehmen mit Sitz in <strong className="text-neutral-900">Wuppertal</strong> und 
                stehen für moderne, zuverlässige und zukunftssichere Lösungen. Als zertifizierter Fachbetrieb nach 
                <strong className="text-neutral-900"> DIN ISO 9001</strong> arbeiten wir mit klar definierten Prozessen und höchsten Qualitätsstandards.
              </p>
              <p>
                Was uns von vielen Mitbewerbern unterscheidet? Unsere konsequente Ausrichtung auf Qualität und 
                Kundenzufriedenheit. Wir setzen auf moderne Technologien, hochwertige Materialien und eine 
                transparente Kommunikation.
              </p>
            </div>

            {/* Highlights Grid */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              {highlights.map((item, index) => {
                const IconComponent = item.icon;
                return (
                  <div 
                    key={index}
                    data-testid={`about-highlight-${index}`}
                    className="flex items-start gap-3 p-4 bg-white border border-zinc-200"
                  >
                    <IconComponent className="w-6 h-6 text-[#E31E24] flex-shrink-0 mt-0.5" />
                    <div>
                      <div className="font-bold text-neutral-900 text-sm">{item.title}</div>
                      <div className="text-xs text-neutral-500">{item.description}</div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Quote */}
            <blockquote className="border-l-4 border-[#E31E24] pl-6 py-2">
              <p className="text-neutral-700 italic">
                „Zuverlässigkeit, Termintreue und maßgeschneiderte Lösungen sind für uns selbstverständlich."
              </p>
              <footer className="mt-2 text-sm font-medium text-neutral-900">
                — Jonas Hellriegel, Geschäftsführer
              </footer>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
